<script setup lang="ts">
const isLoaded = ref(false)
const isPlaying = ref(false)
const video = useTemplateRef<{ player: { playVideo: () => void } }>('video')

function play() {
  if (video.value?.player) {
    video.value.player.playVideo()
  }
}

function stateChange(event: { data: number }) {
  isPlaying.value = event.data === 1
}
</script>

<template>
  <div class="not-prose">
    <div class="flex items-center justify-center p-5">
      <ScriptYouTubePlayer
        ref="video"
        above-the-fold
        video-id="d_IFKP1Ofq0"
        class="group"
        @ready="isLoaded = true"
        @state-change="stateChange"
      >
        <template #awaitingLoad>
          <div class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-[48px] w-[68px]">
            <svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00" /><path d="M 45,24 27,14 27,34" fill="#fff" /></svg>
          </div>
        </template>
      </ScriptYouTubePlayer>
    </div>
    <div class="text-center">
      <UAlert
        v-if="!isLoaded"
        class="mb-5"
        size="sm"
        color="info"
        variant="soft"
        title="Click to load"
        description="Clicking the video will load the YouTube iframe and start the video."
      />
      <UButton v-if="isLoaded && !isPlaying" @click="play">
        Play Video
      </UButton>
    </div>
  </div>
</template>
